import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';
import { Headline, Layout, Text } from '@oneaudi/unified-web-components';
import { SYS_PAGE_MARGIN_SM } from '@oneaudi/unified-web-common';

type DealerNotesModalProps = {
  copy: string;
  description?: string | null;
  onClose: () => void;
};

const DealerNotesModal: React.FC<DealerNotesModalProps> = ({ copy, description, onClose }) => {
  const { t } = useTranslation();
  const [isModalContentFocused, setIsModalContentFocused] = useState<boolean>(true);

  const onKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      // pressing TAB key switches focus between `ModalContainer` and `CloseModalButton` components
      if (event.key === 'Tab') {
        event.preventDefault();
        if (isModalContentFocused) {
          document.getElementById('modalContainerVDPFSS')?.blur();
          document.getElementById('closeModalVDPFSS')?.focus();
          setIsModalContentFocused(false);
        } else {
          document.getElementById('closeModalVDPFSS')?.blur();
          document.getElementById('modalContainerVDPFSS')?.focus();
          setIsModalContentFocused(true);
        }
      }
    },
    [isModalContentFocused],
  );

  useEffect(() => {
    // focus the ModalContainer right after the Modal is painted on the screen
    document.getElementById('modalContainerVDPFSS')?.focus();
    return () => {
      // focus the InfoIcon component after closing the modal
      document.getElementById('infoIconVDPFSS')?.focus();
    };
  }, []);

  return (
    <Modal onClose={onClose} onKeyDown={onKeyDown} isDealerNotesModal>
      <Layout
        direction={'column'}
        rowGap={SYS_PAGE_MARGIN_SM}
        data-testid="modal-dealer-notes-wrapper"
      >
        <Headline
          tag="h1"
          variant={{
            order: '3',
            type: 'headline',
            weight: 'normal',
          }}
          data-testid="modal-header"
        >
          {copy}
        </Headline>

        <Text
          variant={{
            order: '1',
            type: 'copy',
            style: 'normal',
          }}
          data-testid="modal-text-description"
        >
          {description || t('featuresAndSpecsSection.categories.optionalEquipment.noDetails')}
        </Text>
      </Layout>
    </Modal>
  );
};

export default DealerNotesModal;
